// Use the same approach as the theme's main header sticky behavior
$(document).ready(function() {
    // Remove desktop only restriction - work on all screen sizes
    
    const $tabHeader = $('.tab-header-bar');
    if (!$tabHeader.length) return;
    
    let lastScroll = 0;
    let headerHeight = $tabHeader.outerHeight();
    let didScroll = false;
    
    function tab_header_sticky() {
        const scroll = $(window).scrollTop();
        const $mainHeader = $('.hdr_wrap');
        const mainHeaderIsSticky = $mainHeader.hasClass('sticky_hdr');
        
        // Check if consolidated header is active and visible
        const $consolidatedHeader = $('.tab-menu-promo-bar-header');
        const consolidatedHeaderVisible = $consolidatedHeader.hasClass('consolidated-visible');
        
        // If consolidated header is controlling positioning, don't interfere
        if (consolidatedHeaderVisible && $consolidatedHeader.length) {
            return;
        }
        
        if (scroll > headerHeight && scroll > lastScroll) {
            // Scrolling down past header height - remove visible class
            $tabHeader.removeClass('tab-visible animated fadeInDown');
            
            // Reset main header position when hiding tab header
            if (mainHeaderIsSticky) {
                $mainHeader.css('top', '0px');
            }
        } else if (scroll <= headerHeight) {
            // Near top - remove all sticky classes
            $tabHeader.removeClass('tab-sticky tab-visible animated fadeInDown');
            
            // Reset main header position
            $mainHeader.css('top', '');
        } else if (scroll < lastScroll) {
            // Scrolling up - add sticky and show with animation
            $tabHeader.addClass('tab-sticky tab-visible animated fadeInDown');
            
            // Position main header below tab header if it's sticky
            if (mainHeaderIsSticky) {
                $mainHeader.css('top', headerHeight + 'px');
            }
        }
        
        lastScroll = scroll;
    }
    
    $(window).scroll(function() {
        didScroll = true;
    });
    
    // Use same interval approach as theme
    setInterval(function() {
        if (didScroll) {
            tab_header_sticky();
            didScroll = false;
        }
    }, 250);
});